<template>
  <v-container fluid id="visit_procedures">
    <v-row justify="end">
      <v-col cols="5" class="text-right">
        <v-btn color="primary" @click="copyPrevious" v-if="$can('do','POKO_Wizyty_Edycja_Przebiegu') && latest_procedures != null && latest_procedures.length > 0" class="mr-2">Skopiuj z poprzedniej wizyty</v-btn>
        <v-btn color="primary" @click="showAddIcd9=true" v-if="$can('do','POKO_Wizyty_Edycja_Przebiegu')">Dodaj</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
            :items="procedures"
            :headers="headers">
          <template v-slot:item="props">
            <tr>
              <td>{{props.item.icd9_code}}</td>
              <td>{{props.item.description}}</td>
              <td>
                <v-icon small class="mr-2"  v-if="$can('do','POKO_Wizyty_Edycja_Przebiegu')" @click="removeProcedure(props.item.id)" title="Usuń procedurę">fa-trash-alt</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <ICD9PIcker v-if="showAddIcd9" :visible="showAddIcd9" @close="showAddIcd9 = false" :visitid="visitid" :domyslne="domyslne_rozdzialy" @category_selected="categorySelected"></ICD9PIcker>
  </v-container>
</template>

<script>
import ICD9PIcker from "@/components/visits/ICD9PIcker";
import {icdService, visitService} from "@/services";
import swal from "sweetalert";
export default {
  name: "VisitProcedures",
  components: {ICD9PIcker},
  props: ["visitid", "items", "latest_procedures"],
  data() {
    return {
      headers: [
        {text: 'Kod ICD9', sortable: false, align: 'left', value: 'icd9_code'},
        {text: 'Opis', sortable: false, align: 'left', value: 'description'},
        {text: 'Akcje', sortable: false, align: 'left', value: 'id'}
      ],
      showAddIcd9: false,
      domyslne_rozdzialy: []
    }
  },
  mounted() {
    this.getTherapistDefaultCategories()
  },
  computed: {
    procedures: {
      get: function() {
        return this.items ? this.items : []
      },
      set: function(val) {
        this.$emit('update:items',val)
      }
    }
  },
  methods: {
    copyPrevious()
    {
      this.latest_procedures.forEach(elem => {
        visitService.AddVisitProcedure({
          visitID: this.visitid,
          icd9_code: elem.icd9_code,
          description: elem.description
        }).then((result) => {
          let existingItem = this.procedures.find(x=>x.id == result.data.result.id)
          if(!existingItem)
          {
            let arr = [...this.procedures]
            arr.push(result.data.result)
            this.procedures = arr;
          }
        }).catch(()=> {
          this.showError('Błąd dodawania procedury medycznej.')
        })
      })
    },
    removeProcedure(id)
    {
      swal({
        title: "Czy na pewno?",
        text: "Czy na pewno chcesz usunąć tę procedure medyczną?",
        icon: "warning",
        buttons: ["Nie", "Tak"],
        dangerMode: true
      }).then(confirmed => {
        if (confirmed) {
          visitService.DeleteVisitProcedure(id).then(()=> {
            let arr = [...this.procedures]

            arr.splice(this.procedures.findIndex(function(i){
              return i.id === id;
            }), 1);
            this.procedures = arr

          }).catch(()=>{
            this.showError('Błąd usuwania procedury medycznej.')
          })
        }
      });

    },
    categorySelected(value){
      visitService.AddVisitProcedure({
        visitID: this.visitid,
        icd9_code: value.kod,
        description: value.opis
      }).then((result) => {
          let existingItem = this.procedures.find(x=>x.id == result.data.result.id)
          if(!existingItem)
          {
            let arr = [...this.procedures]
            arr.push(result.data.result)
            this.procedures = arr;
          }
      }).catch(()=> {
        this.showError('Błąd dodawania procedury medycznej.')
      })
      this.showAddIcd9 = false
    },
    getTherapistDefaultCategories()
    {
      icdService.GetTherapistICD9Categories(this.visitid).then((result)=> {
        this.domyslne_rozdzialy = result.data.result
      }).catch(()=> {
        this.showError('Błąd pobierania domyslnych kategorii ICD9')
      })
    },
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      })
    }
  }
}
</script>

<style scoped>

</style>